import * as React from "react";

import "./payment.scss";

import {cs} from "@Common/react/chain-services";

import {PaymentParts} from "./payment-parts/payment-parts";

export const Payment = ({payments, onApprove}:{
    payments    : Parameters<typeof PaymentParts>[0]['payments'],
    onApprove   : () => void,
}) => cs(
    () => onApprove && (
        <div className="payment payment-52j">
            {payments && (
                PaymentParts({payments})
            )}

            <button
                onClick={onApprove}
                xd-qa-type="button"
                xd-qa-name="Approve"
            >Approve</button>
        </div>
    ),
);

